/**
 * 任务组相关(包括任务)
 */

import BaseAuthClient from './baseAuth';

class WorkerClient extends BaseAuthClient {
  constructor() {
    super({
      baseURL: '/api'
    });
  }
}

const workerClient = new WorkerClient();

export default workerClient;

// 项目详情
export const projectDetail = (option: any) => workerClient.get(`/v1/workbench/projectdetail`, option);


